//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import {
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasAllFeatures,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export const states = {
  socialresponse: StateFactory({
    url: '/social-inbox',
    template: componentNameToTemplate('socialResponsePage'),
    data: {
      title: 'Social Inbox',
      navGroup: NavGroup.SOCIAL_INBOX,
      hasAccess: () => hasAllFeatures(FeatureNames.SocialResponse),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.socialresponse',
        () => import('@social-response/socialResponseApp'),
      ),
    },
  }),
};
